import React from "react";
import FinsireButton from "./FinsireButton";
import { GoDownload } from "react-icons/go";
import axios from "axios";
import { decryptText } from "../utils/cipherText";

const EligibleTopBar = ({
  searchQuery,
  setSearchQuery,
  showButton,
  downloadPageWord,
  page,
}) => {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);

  const handlePageDownload = async () => {
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/download_${
          // (downloadPageWord === "transactions" && "transaction") ||
          // (downloadPageWord === "distributors" && "distributor") ||
          // "selected"
          downloadPageWord
        }_csv?page_name=${downloadPageWord}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res.data.download_url);

      const link = document.createElement("a");
      link.href = res.data.download_url;
      link.download = "data.csv";
      link.textContent = "Download CSV";
      // Append the link to the DOM and trigger the download
      document.body.appendChild(link);
      link.click();
      // Clean up the object URL
      URL.revokeObjectURL(link.href);
      // Remove the link from the DOM
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex w-full lg:max-h-14 py-4">
      <div className="flex flex-row justify-between items-center w-full">
        <div>
          <p className="text-[#262626] text-base font-bold">
            List of {page === "Distributors" ? page : "Eligible Users"}
          </p>
        </div>
        <div className="flex flex-row items-center gap-x-4 relative">
          <form className="">
            <div className="relative w-[70%]">
              <input
                value={searchQuery}
                id="search-field"
                className="w-[210px] text-xs h-8 border border-[#E0E0E0] rounded bg-[#F8F8F8] px-3 py-[14px] focus:outline-none placeholder:text-[#848484]"
                placeholder="Search"
                name="search"
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setSearchQuery(e.target.value);
                  }
                }}
              ></input>
            </div>
          </form>
          {/* {userType !== "distributors" && showButton !== false && (
            <div onClick={() => handlePageDownload()}>
              <FinsireButton text={"Download"} icon={GoDownload} />
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default EligibleTopBar;
